import React from 'react';
import { User as PersonOutlineOutlinedIcon } from 'lucide-react';

import { useAppDispatch, useAppSelector } from 'src/store';
import { setFormState } from 'src/app/surveys/views/new-survey-design/state/newSurveyDesignSlice';
import Input from 'src/shared/components/input/Input';
import { getCurrentSurveyDesignFormState } from 'src/app/surveys/views/new-survey-design/state/newSurveyDesignSelector';

import surveyDesignstyles from 'src/app/surveys/views/new-survey-design/NewSurveyDesign.module.scss';
import QuestionButtonHelp from 'src/shared/components/question-button-help/QuestionButtonHelp';
import styles from './CustomerContacts.module.scss';

export const CustomerContacts = () => {
    const formState = useAppSelector(getCurrentSurveyDesignFormState);
    const { projectLeadRole } = formState;

    const dispatch = useAppDispatch();

    return (
        <div className={surveyDesignstyles.formSection}>
            <div className={surveyDesignstyles.formSectionTitle}>Project contact</div>

            <div className={styles.projectContact}>
                <div className={styles.userIcon}>
                    <PersonOutlineOutlinedIcon />
                </div>
                <div className={styles.contactDetails}>
                    <div className={styles.contactDetailsName}>{formState.projectLeadName || 'Not set'}</div>
                    <div>{formState.projectLeadEmail || 'Not set'}</div>
                </div>
                <div className={styles.role}>
                    <div className={styles.roleTitle}>
                        Job title <QuestionButtonHelp type='api' slug='project-definition-role' />
                    </div>
                    <Input
                        placeholder='Type job title'
                        value={projectLeadRole}
                        onChange={event => dispatch(setFormState({ projectLeadRole: event.target.value }))}
                    />
                </div>
            </div>
        </div>
    );
};
export default CustomerContacts;
